import { render, staticRenderFns } from "./template-message-add.vue?vue&type=template&id=df72ccb4&scoped=true&"
import script from "./template-message-add.vue?vue&type=script&lang=js&"
export * from "./template-message-add.vue?vue&type=script&lang=js&"
import style0 from "./template-message-add.vue?vue&type=style&index=0&id=df72ccb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df72ccb4",
  null
  
)

export default component.exports